import GenericAction from '@Actions/generic-action';
import { Actions } from '@Context/common/general/context';
import { AnalyticsEvents } from '@Enums';
import { getAuth, updatePassword } from 'firebase/auth';
export default class UpdatePassword extends GenericAction {
  runAction() {
    const Action = async () => {
      try {
        const response = await updatePassword(getAuth().currentUser, this._payload.password);
        this._state.auth.events.passwordUpdated.emit(response);
        // Send analytics event
        this._dispatch({
          type: Actions.AppActions.AnalyticsEvent,
          payload: { type: AnalyticsEvents.user_password_changed }
        });
        super.onSuccess(response);
        return Promise.resolve();
      } catch (error) {
        super.onError(error);
        return Promise.reject(error);
      }
    };
    Action();
  }
}